// De la ruta en la que estás parado al módulo del que habla.
//
// Es lo que hace que el panel de ayuda muestre primero lo de ESTA pantalla, que
// es la diferencia entre una ayuda y un manual.
//
// La lista se escribe una vez y se verifica contra el router real en un test: si
// alguien renombra una ruta, la ayuda contextual dejaría de encontrar su módulo
// en silencio — el mismo modo de falla que ya tuvieron los mensajes de Ajustes
// dos veces.

const POR_PREFIJO: Array<[string, string]> = [
  ['/email', 'email'],
  ['/leads', 'leads'],
  ['/embudos', 'funnels'],
  ['/contacts', 'contacts'],
  ['/formularios', 'forms'],
  ['/proyectos', 'projects'],
  ['/reports', 'reports'],
  ['/tasks', 'tasks'],
  ['/facturacion', 'billing'],
  ['/mensajes', 'messaging'],
];

/** El módulo de una ruta, o null si esa pantalla no es de ningún módulo
 *  (el inicio, Ajustes, el historial del asistente). */
export function rutaAModulo(pathname: string): string | null {
  for (const [prefijo, modulo] of POR_PREFIJO) {
    if (pathname === prefijo || pathname.startsWith(`${prefijo}/`)) return modulo;
  }
  return null;
}

/** Los prefijos declarados, para que el test los cruce con el router real. */
export const PREFIJOS_DE_MODULO = POR_PREFIJO.map(([p]) => p);
